"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessUnitSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
exports.businessUnitSchemaDef = {
    id: joi_1.default.string().required(),
    shortName: joi_1.default.string().required(),
};
